import { auth } from './firebase';
import { sessionService } from '@/services/session.service';

let inflight: Promise<void> | null = null;

export function refreshSession(): Promise<void> {
  // Single-flight : les appels concurrents partagent la même promesse et reçoivent
  // donc le même résultat (succès comme échec). Avant, un échec résolvait quand même
  // les appelants en attente, qui croyaient à tort la session rafraîchie.
  if (inflight) return inflight;

  inflight = (async () => {
    try {
      const user = auth.currentUser;
      if (!user) throw new Error('No Firebase user to refresh');
      const idToken = await user.getIdToken(true);
      await sessionService.setSession(idToken, 'login');
    } finally {
      inflight = null;
    }
  })();

  return inflight;
}
